import { PendingSyncMarketplaceOrderListPage } from "@/features/pending-sync-marketplace-order/pages/PendingSyncMarketplaceOrderListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pending-sync-marketplace-order/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["it.monitoring.pending_marketplace_order"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: PendingSyncMarketplaceOrderListPage,
});
